import Quill from "quill";

const Embed = Quill.import("blots/embed");

class MentionBlot extends Embed {

    static create(data) {
        const node = super.create();
        node.innerText = `${data.denotationChar || '@'}${data.value}`
        // store data
        node.setAttribute('data-denotation-char', data.denotationChar)
        node.setAttribute('data-id', data.id)
        node.setAttribute('data-value', data.value)

        return MentionBlot.setDataValues(node, data);

    }

    static setDataValues(element, data) {
        // the extended Embed constructor has added contenteditable=false to the outermost span,
        // we want to override that in favour of ones applied to the child elements inside create()
        setTimeout(() => {
            element.getElementsByTagName("span")[0].setAttribute("contenteditable", "false");
        }, 0);

        const domNode = element;
        Object.keys(data).forEach(key => {
            domNode.dataset[key] = data[key];
        });
        return domNode;
    }

    static value(domNode) {
        return domNode.dataset;
    }

    // android Gboard backspace does not fire onkeypress events, resulting in the caret
    // breaking into the read-only blot element. - so we need to handle edit events inside the blot child elements as well
    update(mutations, context) {
        for (const mutation of mutations) {
            if (mutation.type != 'childList') continue
            if (mutation.removedNodes.length == 0) continue

            const nodeType = mutation.removedNodes[0].nodeType
            setTimeout(() => this.remove(nodeType), 0)
            return
        }

        const unhandledMutations = mutations.filter((m) => m.type != 'childList')
        super.update(unhandledMutations, context)
    }

    attach() {
        super.attach()

        if (!this.mounted) {
            this.mounted = true
            this.clickHandler = this.getClickHandler()
            this.domNode.addEventListener('click', this.clickHandler, false)
        }
    }

    detach() {
        super.detach()
        this.mounted = false
        if (this.clickHandler) {
            this.domNode.removeEventListener('click', this.clickHandler)
            this.clickHandler = null
        }
    }

    getClickHandler() {
        return (e) => {
            const event = this.buildEvent('mention-clicked', e)
            window.dispatchEvent(event)
            e.preventDefault()
        }
    }

    buildEvent(name, e) {
        const event = new Event(name, {
            bubbles: true,
            cancelable: true
        })
        event.value = Object.assign({}, this.domNode.dataset)
        event.event = e
        return event
    }


}

MentionBlot.blotName = "mention";
MentionBlot.tagName = "span";
MentionBlot.className = "mention";


Quill.register(MentionBlot);
